import React, { useEffect, useState } from "react";
import { MdOutlineKeyboardBackspace } from "react-icons/md";
import { RiRefreshFill } from "react-icons/ri";
import { motion } from "framer-motion";
import EmptyCart from "../assets/img/emptyCart.svg";
import CartItem from "../components/CartItem";
import { useSelector, useDispatch } from "react-redux";
import { clearCartItems, closeCart, setCartItems, setNumberOfCart, setSelectCart } from "../context/actions/cartActions";
import { createMoreCart, createOrderFromStaff, getAllCartFromStaff, getAllCartItems, getCartFromStaff, updateAllCartItemQuantitiesToZero, updateAllCartItemQuantitiesToZeroStaff } from "../api";
import { Link } from 'react-router-dom';
import { BiPlus } from "react-icons/bi";
import { alertNULL, alertSuccess } from "../context/actions/alertActions";

const CartContainer = () => {
  const dispatch = useDispatch();
  const cartItems = useSelector(state => state.cart);
  const user = useSelector(state => state.user);
  const numberOfCartStaff = useSelector(state => state.cart.numberStaffCart)
  const selectedOrderNumber = useSelector(state => state.cart.selectedCart)
  const [paymentMethod, setPaymentMethod] = useState('Tiền mặt')
  const [paymentStatus, setPaymentStatus] = useState(false)
  const [loading, setLoading] = useState(false);
  const [paymentNumber, setPaymentNumber] = useState('')
  const [isProcessing, setIsProcessing] = useState(false)

  const handleConfirmForStaff = async () => {
    setIsProcessing(true)
    const orderData = {
      orders: cartItems.items,
      user: user,
      paymentMethod: paymentMethod,
    }
    try {
      const result = await createOrderFromStaff(orderData)
      if (result) {
        try {
          await updateAllCartItemQuantitiesToZeroStaff(user?.user_id, selectedOrderNumber);
          const updatedCartItems = cartItems?.items.map((item) => ({
            ...item,
            quantity: 0,
          }));
          dispatch(setCartItems({ items: updatedCartItems }));
          dispatch(clearCartItems())
          dispatch(alertSuccess("Nhập đơn thành công!!"));
          setTimeout(() => {
            dispatch(alertNULL());
          }, 3000);
        } catch (error) {
          console.error("Error clearing cart:", error);
        }
      } else {
        // Handle error
        console.error("Error creating order.");
      }
      setIsProcessing(false)
    } catch (error) {
      console.error('Error creating order:', error);
    }
  }

  const handleClearCartInCart = async () => {
    try {
      await updateAllCartItemQuantitiesToZero(user?.user_id);
      // Create an array of updated cart items with quantity set to 0
      const updatedCartItems = cartItems?.items.map((item) => ({
        ...item,
        quantity: 0,
      }));

      // Dispatch the updated cart items to the Redux store
      dispatch(setCartItems({ items: updatedCartItems }));
    } catch (error) {
      console.error("Error clearing cart:", error);
    }
  };

  // Calculate the total price of items in the cart
  const calculateTotal = () => {
    if (cartItems.items && cartItems.items.length > 0) {
      return cartItems.items.reduce(
        (total, item) => total + parseFloat(item.product_price) * item.quantity,
        0
      );
    }
    return 0;
  };
  const tot = calculateTotal();

  const handleFetchNumberCart = async () => {
    await getAllCartFromStaff(user?.user_id).then((data) => {
      dispatch(setNumberOfCart(data.numberOfOrderNumbers));
    })
  }
  const handleAddMoreCart = async () => {
    await createMoreCart(user?.user_id, numberOfCartStaff)
      .then((data) => {
        console.log('Cart created/updated:', data);
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    handleFetchNumberCart()
  }

  const CheckIsStaff = () => {
    return user?.role === "Staff"
  }


  const handleRadioChange = (e) => {
    if (e.target.id === "cashPayment") {
      setPaymentMethod("Tiền mặt");
    } else if (e.target.id === "qrPayment") {
      setPaymentMethod("Thanh toán QR");
    }
  };

  function getCurrentTimeAndDate() {
    const now = new Date();

    // Format the time (H:MM)
    const hours = now.getHours().toString().padStart(2, '0');
    const minutes = now.getMinutes().toString().padStart(2, '0');
    const timeString = `${hours}${minutes}`;

    // Format the date (YYYY-MM-DD)
    const year = now.getFullYear();
    const month = (now.getMonth() + 1).toString().padStart(2, '0');
    const day = now.getDate().toString().padStart(2, '0');
    const dateString = `${day}${month}${year}`;

    const currenttime = timeString + dateString
    return currenttime
  }

  const handleOrderNumberClick = async (index) => {
    await dispatch(setSelectCart(index + 1));
  };

  return (
    <motion.div
      initial={{ opacity: 0, x: 200 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: 200 }}
      className="fixed top-0 right-0 w-full md:w-375 h-screen bg-white drop-shadow-md flex flex-col z-[101]"
    >
      <div className="w-full h-auto flex items-center justify-between p-4 cursor-pointer">
        <motion.div whileTap={{ scale: 0.75 }} onClick={() => {
          dispatch(closeCart())
        }}>
          <MdOutlineKeyboardBackspace className="text-textColor text-3xl" />
        </motion.div>
        <p className="text-textColor text-lg font-semibold">Cart</p>

        <motion.p
          whileTap={{ scale: 0.75 }}
          className="flex items-center gap-2 p-1 px-2 my-2 bg-gray-100 rounded-md hover:shadow-md  cursor-pointer text-textColor text-base"
          onClick={() => handleClearCartInCart()}
        >
          Clear <RiRefreshFill />
        </motion.p>
      </div>
      <motion.div className={`flex ${!CheckIsStaff() && 'hidden'} justify-start`}>
        {numberOfCartStaff && numberOfCartStaff >= 0 && (
          <div className="flex justify-start">
            {Array.from({ length: numberOfCartStaff }).map((_, i) => (
              <div
                key={i}
                className={`${selectedOrderNumber === (i + 1)
                  ? "bg-gradient-to-t font-bold from-orange-100 to-orange-400 border-slate-300"
                  : "bg-gray-200"
                  } rounded-t-xl p-2 cursor-pointer border`}
                onClick={() => handleOrderNumberClick(i)}
              >
                Đơn {i + 1}
              </div>
            ))}
          </div>
        )}
        <p className="text-lg font-bold p-2 flex justify-center items-center cursor-pointer rounded-md bg-orange-300"
        ><BiPlus className=""
          onClick={handleAddMoreCart}
          /></p>

      </motion.div>
      {/* bottom section */}
      {cartItems.items && cartItems.items.length > 0 ? (
        <div className="w-full h-full items-center justify-between bg-cartBg rounded-t-[2rem] flex flex-col">
          {/* cart Items section */}
          <div className="w-full max-h-[500px] px-6 pt-10 flex flex-col gap-3 overflow-y-scroll scrollbar-none">
            {loading ? (
              <div className="font-bold text-white">Loading...</div>
            ) : (
              <>
                {cartItems.items &&
                  cartItems.items.length > 0 &&
                  cartItems.items.map((item) => (
                    <CartItem
                      key={item.productId}
                      item={item}
                      orderNumber={selectedOrderNumber}
                    />
                  ))}
              </>
            )}
          </div>

          {/* cart total section */}
          <div className="w-full h-auto bg-cartTotal rounded-t-[2rem] flex flex-col items-center justify-end px-8 py-2">
            <div className="w-full flex items-center justify-between">
              <p className="text-gray-400 text-lg">Tổng cộng</p>
              <p className="text-gray-400 text-lg">VNĐ {parseFloat((tot)).toLocaleString('en-US')}</p>
            </div>
            <div className="w-full flex items-center justify-between">
              <p className="text-gray-400 text-lg">Phí ship</p>
              <p className="text-gray-400 text-lg">VNĐ 0</p>
            </div>
            {CheckIsStaff() && (
              <>
                <div className="w-full flex items-center justify-around text-white">
                  <label htmlFor="cashPayment">Thanh toán tiền mặt</label>
                  <input
                    type="radio"
                    name="paymentMethod"
                    id="cashPayment"
                    checked={paymentMethod === "Tiền mặt"}
                    onChange={handleRadioChange}
                  />
                  <label htmlFor="qrPayment">Thanh toán QR</label>
                  <input
                    type="radio"
                    name="paymentMethod"
                    id="qrPayment"
                    checked={paymentMethod === "Thanh toán QR"}
                    onChange={(e) => {
                      handleRadioChange(e); // Call function 1
                      setPaymentNumber(getCurrentTimeAndDate()); // Call function 2
                    }}
                  />
                </div>
                <p className="text-white">Khách hàng chọn : <span className="text-emerald-300">{paymentMethod}</span></p>
                {paymentMethod === "Thanh toán QR" && (
                  <>
                    <div className='flex flex-col gap-2 justify-center items-center'>
                      <img src={`https://img.vietqr.io/image/techcombank-19033190221012-7ux3Vou.jpg?amount=${tot}&addInfo=${"DOHA" + tot + "N" + paymentNumber}%5C&accountName=${'PHAN QUOC CUONG'}`} alt="" className='w-32' />
                    </div>
                    <p className="text-white">Tình trạng :
                      {paymentStatus ? (<span className="bg-emerald-400"> Thanh toán thành công </span>) : (<span className="bg-red-500">Chưa thanh toán </span>)}
                    </p>
                  </>
                )}
              </>
            )}

            <div className="w-full border-b border-gray-600 my-2"></div>

            <div className="w-full flex items-center justify-between">
              <p className="text-gray-200 text-xl font-semibold">Tổng cộng</p>
              <p className="text-gray-200 text-xl font-semibold">
                VNĐ {parseFloat((tot)).toLocaleString('en-US')}
              </p>
            </div>

            {user && (user.role === "user") ? (
              <Link to="/checkout" className="w-full">
                <motion.button
                  whileTap={{ scale: 0.8 }}
                  type="button"
                  className="w-full p-2 rounded-full bg-gradient-to-tr from-orange-400 to-orange-600 text-gray-50 text-lg my-2 hover:shadow-lg"
                  onClick={() => {
                    dispatch(closeCart());
                  }}
                >
                  Thanh toán
                </motion.button>
              </Link>
            ) : CheckIsStaff() ? (
              <motion.button
                whileTap={{ scale: 0.8 }}
                type="button"
                className={`w-full p-2 rounded-full ${!paymentStatus && paymentMethod === "Thanh toán QR" ? ('bg-slate-300 text-slate-500') : ('bg-gradient-to-tr from-emerald-400 to-emerald-600 text-gray-50')}  text-lg my-2 hover:shadow-lg`}
                onClick={handleConfirmForStaff}
                disabled={(!paymentStatus && paymentMethod === "Thanh toán QR") || isProcessing}
              >
                Xác nhận đơn hàng
              </motion.button>
            ) : (
              <Link to="/login" className="w-full">
                <motion.button
                  whileTap={{ scale: 0.8 }}
                  type="button"
                  className="w-full p-2 rounded-full bg-gradient-to-tr from-orange-400 to-orange-600 text-gray-50 text-lg my-2 hover:shadow-lg"
                >
                  Đăng nhập để thanh toán
                </motion.button>
              </Link>
            )}


          </div>
        </div>
      ) : (
        <div className="w-full h-full flex flex-col items-center justify-center gap-6">
          <img src={EmptyCart} className="w-300" alt="" />
          <p className="text-xl text-textColor font-semibold">
            Thêm sản phẩm vào giỏ
          </p>
        </div>
      )}
    </motion.div>
  );
};

export default CartContainer;